export default __webpack_public_path__ + "static/media/codefry.7d01d87b.png";